import React, { useEffect } from 'react'
import * as styles from '../styles/components/typewriter.module.scss'
import { animate, motion, useMotionValue, useReducedMotion, useTransform } from 'framer-motion'

export interface TypeWriterProps {
    text: string
    durationInS?: number
    enabled?: boolean
}

const TypeWriter = ({ text, durationInS = 0.85, enabled = true }: TypeWriterProps) => {
    const prefersReducedMotion = useReducedMotion()
    const count = useMotionValue(0)
    const rounded = useTransform(count, (latest) => Math.round(latest))
    const displayedText = useTransform(rounded, (latest) => text.slice(0, latest))

    useEffect(() => {
        if (enabled) {
            const controls = animate(count, text.length, {
                type: 'tween',
                duration: durationInS,
                ease: 'easeInOut',
            })
            return controls.stop
        }
    }, [enabled, count, text.length, durationInS])

    if (prefersReducedMotion) {
        return <div>{text}</div>
    }

    // Write out the text on top of a transparent placeholder so that the text
    // doesn't jump around as the animation proceeds (e.g. when a new line is added)
    return (
        <div className={styles.container}>
            {
                <div className={styles.placeholder} aria-hidden="true">
                    {text}
                </div>
            }

            <motion.div className={styles.text}>
                {displayedText}
            </motion.div>
        </div>
    )
}

export default TypeWriter
